export default "__VITE_ASSET__Dsu5AO1J__"